import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

const selectors = {
  cardFeedContent: '[data-card-feed-content]',
};

export default class DynamicCollectionCarousel {
  constructor(section) {
    this.el = section.el;
    this.section = section;
    this.cardFeedContent = this.el.querySelector(selectors.cardFeedContent);

    this.carousel = initCarousel(
      this.el,
      {
        perPage: 2,
        arrows: true,
        gap: '1rem',
        mediaQuery: 'min',
        type: 'slide',
        drag: true,
        snap: true,
        perMove: 1,
        breakpoints: {
          [unitlessBreakpoints.md]: {
            perPage: 4,
          },
          [unitlessBreakpoints.lg]: {
            perPage: 8,
          },
        },
      },
      true,
    );
  }
}
